import { c as _c } from "react/compiler-runtime";
import { Link } from '@algoacademy/design-system/web/actions/Link';
import { P2 } from '@algoacademy/design-system/web/typography/Paragraph';
import { algoliasearch } from 'algoliasearch';
import { Configure, InstantSearch } from 'react-instantsearch';
import { ALGOLIA_INDEXES } from '@/app/baza/_helpers/globalVariables';
import { Dialog } from './_components/CustomDialog';
import { CustomSearchBox } from './_components/CustomSearchBox';
import AlgoliaLogo from './_svg/AlgoliaLogo';
export const searchClient = algoliasearch(process.env.NEXT_PUBLIC_ALGOLIA_APP_ID ?? '', process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_KEY ?? '');
type SearchDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  SearchResultComponent: React.FC;
};
export function SearchDialog(t0) {
  const $ = _c(9);
  const {
    isOpen,
    onClose,
    SearchResultComponent
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Configure hitsPerPage={10} typoTolerance="false" restrictSearchableAttributes={["collection.name", "article.name"]} />;
    t2 = <CustomSearchBox />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== SearchResultComponent) {
    t3 = <InstantSearch searchClient={searchClient} indexName={ALGOLIA_INDEXES.PUBLIC_COLLECTIONS_AND_ARTCILES}>{t1}{t2}<SearchResultComponent /></InstantSearch>;
    $[2] = SearchResultComponent;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex justify-end"><Link href="https://www.algolia.com/developers/" target="_blank" className="flex items-center gap-2"><P2 className="text-contentTertiary">Search by</P2><AlgoliaLogo className="text-algoliaBlue dark:text-white" /></Link></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== isOpen || $[6] !== onClose || $[7] !== t3) {
    t5 = <Dialog open={isOpen} onClose={onClose} className="max-w-3xl">{t3}{t4}</Dialog>;
    $[5] = isOpen;
    $[6] = onClose;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}